import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import ExportModel from '@/views/Project/Observation/model/export'
import SelectLanguage from '@/components/Select/language.vue'
import { filterToParams } from '@/types/observation'

@Component({
    inheritAttrs: false,
    name: 'ExportDialog',
    components: { DialogTemplate, SelectLanguage },
})
export default class ExportDialog extends Mixins<MixinInterface>() {
    get observationId() {
        return this.$route.params.observationId
    }

    loading = false
    deviceTimeZone = this.guessTimezone()
    format = 'pdf'
    includeAttachments = false
    includeFilters = true
    exportLanguage = 'eng'
    exportByEmail = false
    emailTo: Array<string> = ['']
    emailMessage = ''

    get meMode() {
        return this.$store.getters.meMode
    }

    mounted() {
        this.exportLanguage = this.userLanguage ? this.userLanguage : 'eng'
    }

    addEmail() {
        this.emailTo.push('')
    }

    removeEmail(index) {
        this.emailTo.splice(index, 1)
    }

    get observationFilter() {
        return this.$store.getters.observationFilter
    }

    get observationSort() {
        return this.$store.getters.observationSort
    }
    valid = false
    get validateExport() {
        return (
            this.valid && ((this.exportByEmail && this.emailTo.length > 0) || !this.exportByEmail)
        )
    }

    async createExport() {
        if (this.validateExport) {
            this.loading = true

            let data = {
                type: 'export',
                attributes: {
                    format: this.format,
                    ...(this.exportByEmail &&
                        this.observationId &&
                        this.emailTo.length && { emailTo: this.emailTo }),
                    ...(this.exportByEmail &&
                        this.observationId &&
                        this.emailMessage &&
                        this.emailTo.length && { emailMessage: this.emailMessage }),
                },
                relationships: {
                    project: {
                        data: {
                            id: this.currentProjectId,
                            type: 'project',
                        },
                    },
                },
            }

            let params = {}
            if (this.observationId) {
                params = {
                    'filter[id]': this.observationId,
                    'filter[visibility]': 'public',
                    includeAttachments: this.includeAttachments,
                    exportLanguage: this.exportLanguage,
                }
            } else {
                const newParams = filterToParams(
                    this.observationSort,
                    this.observationFilter,
                    'export',
                    'project',
                    this.meMode,
                    this.currentUser.id
                )

                params = {
                    'filter[visibility]': 'public',
                    includeAttachments: this.includeAttachments,
                    exportLanguage: this.exportLanguage,
                    ...(this.includeFilters && newParams),
                }
            }

            let query = {
                filters: params,
                body: { data },
            }

            let res = await ExportModel.post(query).catch(() => {
                this.loading = false
            })

            if (res) {
                if (this.exportByEmail) {
                    this.$store.commit('setSuccessSnackBar', {
                        title: this.$t(`observation_fe['dialog.export.emailTo.success.title']`),
                        subtitle: this.$t(
                            `observation_fe['dialog.export.emailTo.success.subtitle']`
                        ),
                    })
                } else {
                    await this.getExport(res)
                    this.$store.commit('setSuccessSnackBar', {
                        title: this.$t(`observation_fe['dialog.export.export.success.title']`),
                        subtitle: this.$t(
                            `observation_fe['dialog.export.export.success.subtitle']`
                        ),
                    })
                }

                this.$emit('close', false)
            }
        }
    }

    async getExport(data: any) {
        try {
            let res = await ExportModel.get(data._id)
            if (res.status == 'failed') {
                this.$store.commit('setErrorSnackBar', {
                    title: this.$t(`observation_fe['dialog.export.error.exportFailed.title']`),
                    subtitle: this.$t(
                        `observation_fe['dialog.export.error.exportFailed.subtitle']`
                    ),
                })
                this.loading = false
            } else if (res.status == 'completed') {
                this.$store.commit('closeSnackbar')
                this.loading = false
                ExportModel.download(res.fileId, res.filename)
            } else {
                setTimeout(() => {
                    this.getExport(res)
                }, 3000)
            }
        } catch (error) {
            //
        }
    }
}
